import { Link } from 'react-router-dom';

function AboutPage() {
  return (
    <div>
      <section className="mx-auto grid max-w-7xl gap-12 px-4 pb-20 pt-12 md:grid-cols-2 md:px-8">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Nuestra historia</span>
          <h1 className="mt-4 text-4xl font-extrabold leading-tight tracking-tight md:text-6xl">
            Arquitectos de la evolución digital.
          </h1>
          <p className="mt-6 text-lg text-onSurfaceVariant">
            En Krystal combinamos precisión matemática, diseño funcional y estrategia de negocio para
            transformar desafíos complejos en sistemas claros y escalables.
          </p>
        </div>
        <div className="relative">
          <div className="aspect-square overflow-hidden rounded-2xl bg-surfaceContainerLow">
            <img
              src="/assets/images/about/Desarrolladores.png"
              alt="Equipo de desarrolladores"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 rounded-xl bg-primary p-6 text-white shadow-xl">
            <p className="text-3xl font-extrabold">12+</p>
            <p className="text-xs font-semibold uppercase tracking-widest">Años de innovación</p>
          </div>
        </div>
      </section>

      <section className="bg-surfaceContainerLow py-20">
        <div className="mx-auto grid max-w-7xl gap-px overflow-hidden rounded-2xl bg-outlineVariant/25 px-4 md:grid-cols-2 md:px-8">
          <article className="bg-white p-10 md:p-14">
            <span className="material-symbols-outlined text-primary">lightbulb</span>
            <h2 className="mt-5 text-3xl font-bold">Nuestra misión</h2>
            <p className="mt-4 text-onSurfaceVariant">
              Empoderar organizaciones mediante soluciones de software que eleven su eficiencia y su
              capacidad de innovación.
            </p>
          </article>
          <article className="bg-white p-10 md:p-14">
            <span className="material-symbols-outlined text-primary">visibility</span>
            <h2 className="mt-5 text-3xl font-bold">Nuestra visión</h2>
            <p className="mt-4 text-onSurfaceVariant">
              Ser referentes en consultoría tecnológica para compañías que buscan excelencia técnica
              y evolución sostenida.
            </p>
          </article>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-24 md:px-8">
        <span className="text-xs font-bold uppercase tracking-widest text-primary">Valores centrales</span>
        <h2 className="mt-3 text-3xl font-extrabold tracking-tight md:text-4xl">
          Los pilares que sostienen nuestro enfoque.
        </h2>
        <div className="mt-12 grid gap-10 md:grid-cols-3">
          <article>
            <p className="text-6xl font-thin text-surfaceVariant">01</p>
            <h3 className="mt-4 text-xl font-bold">Integridad técnica</h3>
            <p className="mt-3 text-sm text-onSurfaceVariant">
              Soluciones robustas y mantenibles desde la arquitectura hasta la entrega.
            </p>
          </article>
          <article>
            <p className="text-6xl font-thin text-surfaceVariant">02</p>
            <h3 className="mt-4 text-xl font-bold">Estética funcional</h3>
            <p className="mt-3 text-sm text-onSurfaceVariant">
              Diseñamos experiencias útiles, claras y consistentes con los objetivos de negocio.
            </p>
          </article>
          <article>
            <p className="text-6xl font-thin text-surfaceVariant">03</p>
            <h3 className="mt-4 text-xl font-bold">Empatía estratégica</h3>
            <p className="mt-3 text-sm text-onSurfaceVariant">
              Entendemos cada contexto empresarial para construir soluciones alineadas con impacto.
            </p>
          </article>
        </div>
      </section>

      <section className="bg-surface py-20">
        <div className="mx-auto max-w-5xl px-4 md:px-8">
          <h2 className="text-center text-3xl font-extrabold">Nuestra trayectoria</h2>
          <div className="mt-12 space-y-8">
            <article className="rounded-xl bg-white p-6 shadow-sm">
              <p className="text-xl font-bold text-primary">2010</p>
              <p className="font-bold">Fundación de Krystal</p>
              <p className="text-sm text-onSurfaceVariant">Nacemos con foco en software empresarial de alta complejidad.</p>
            </article>
            <article className="rounded-xl bg-white p-6 shadow-sm">
              <p className="text-xl font-bold text-primary">2016</p>
              <p className="font-bold">Motor de replicación</p>
              <p className="text-sm text-onSurfaceVariant">Se crea nuestra joya, un motor de replicacion de datos en tiempo real, para contruir sistemas hibridos Desktop con nube actualizando datos en tiempo real.</p>
            </article>
            <article className="rounded-xl bg-white p-6 shadow-sm">
              <p className="text-xl font-bold text-primary">2025</p>
              <p className="font-bold">Proyecto Camila, framework de consultoría</p>
              <p className="text-sm text-onSurfaceVariant">Creamos todo un marco de trabajo basado en nuestro motor anterior y lo integramos en un modelo único de ejecución.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-24 md:px-8">
        <h2 className="text-3xl font-extrabold md:text-4xl">Liderazgo visionario</h2>
        <p className="mt-3 text-onSurfaceVariant">Un equipo directivo que combina negocio, tecnología y producto.</p>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[
            {
              name: 'Carlos Alberto A.R.',
              role: 'Founder & CEO',
              image: '/assets/images/about/ceo_512_512.png'
            },
            {
              name: 'Javier A.M.',
              role: 'CTO',
              image: '/assets/images/about/cto_512_512.png'
            },
            {
              name: 'Camila Fabiola A.S.',
              role: 'Design Director',
              image: '/assets/images/about/desinger_512_512.png'
            },
            {
              name: 'Maria Elena M.F.',
              role: 'RRHH',
              image: '/assets/images/about/rrhh_512_512.png'
            }
          ].map((member) => (
            <article key={member.name}>
              <img src={member.image} alt={member.name} className="aspect-[4/5] w-full rounded-xl object-cover" />
              <h3 className="mt-4 font-bold">{member.name}</h3>
              <p className="text-xs font-semibold uppercase tracking-widest text-primary">{member.role}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-24 md:px-8">
        <div className="rounded-2xl bg-primaryContainer/10 p-12 text-center">
          <h2 className="text-3xl font-extrabold">¿Listo para construir el futuro?</h2>
          <p className="mx-auto mt-4 max-w-2xl text-onSurfaceVariant">
            Te acompañamos desde la estrategia inicial hasta la operación continua.
          </p>
          <Link to="/contacto" className="mt-7 inline-block rounded-md bg-primary px-7 py-3 font-bold text-white">
            Empecemos un proyecto
          </Link>
        </div>
      </section>
    </div>
  );
}

export default AboutPage;
